/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2021 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import { createAction } from 'redux-actions';

export const APPLY_SETTINGS = 'session/APPLY_SETTINGS';
export const APPLY_VIEW_PLUGINS = 'session/APPLY_VIEW_PLUGINS';
export const CLOSE_SESSION = 'session/CLOSE_SESSION';
export const CONFIGURE_VIEW_PLUGINS = 'session/CONFIGURE_VIEW_PLUGINS';
export const ENABLE_PLUGIN = 'session/ENABLE_PLUGIN';
export const LOAD_PLUGIN = 'session/LOAD_PLUGIN';
export const MODULE_LOADED = 'session/MODULE_LOADED';
export const REMOVE_PLUGIN = 'session/REMOVE_PLUGIN';
export const SELECT_VIEW = 'session/SELECT_VIEW';
export const UNLOAD_PLUGIN = 'session/UNLOAD_PLUGIN';
export const UPDATE_SESSION = 'session/UPDATE_SESSION';

export const applyViewPluginsToOrg = () => createAction(APPLY_VIEW_PLUGINS)('org');
export const applyViewPluginsToUser = () => createAction(APPLY_VIEW_PLUGINS)('user');
export const applySettings = createAction(APPLY_SETTINGS);
export const closeSession = createAction(CLOSE_SESSION);
export const enablePlugin = createAction(ENABLE_PLUGIN);
export const loadPlugin = createAction(LOAD_PLUGIN);
export const moduleLoaded = createAction(MODULE_LOADED);
export const removePlugin = createAction(REMOVE_PLUGIN);
export const selectView = createAction(SELECT_VIEW);
export const unloadPlugin = createAction(UNLOAD_PLUGIN);
export const updatePluginConfig = createAction(CONFIGURE_VIEW_PLUGINS);
export const updateSession = createAction(UPDATE_SESSION);
